import Vue from 'vue'
import Router from 'vue-router'

import routeMonitoring from './routeMonitoring'
import routeAccountTypes from './routeAccountTypes'
import routePartners from './routePartners'
import routeAgencies from './routeAgencies'
import routeClients from './routeClients'
import routeUsers from './routeUsers'
import routeUserRegistration from './routeUserRegistration'
import routeDrivers from './routeDrivers'
import routeVehicles from './routeVehicles'
import routeVehicleExpenses from './routeVehicleExpenses'
import routeVehicleGroups from './routeVehicleGroups'
import routeUnitsArchives from './routeUnitsArchives'
import routeUnitsSwapping from './routeUnitsSwapping'
import routeUnitsTransfer from './routeUnitsTransfer'
import routeUnitGroups from './routeUnitGroups'
import routeUnits from './routeUnits'
import routeCfgTemplates from './routeCfgTemplates'
import routeReports from './routeReports'
import routeEventProfiles from './routeEventProfiles'
import routeEventPools from './routeEventPools'
import routeSimCards from './routeSimCards'
import routeGDSPOSimCards from '@/router/routeGDSPOSimCards'
import routeUnitCommands from '@/router/routeUnitCommands'
import routeApiBridges from '@/router/routeApiBridges'
import routeAssetTransfer from '@/router/routeAssetTransfer'

Vue.use(Router)

export default new Router({
  routes: [
    {
      name: 'home',
      path: '/',
      component: () => import('@/views/dashboards/Dashboard')
    },
    ...routeMonitoring,
    ...routeAccountTypes,
    ...routePartners,
    ...routeAgencies,
    ...routeClients,
    ...routeUsers,
    ...routeApiBridges,
    ...routeUserRegistration,
    ...routeDrivers,
    ...routeVehicles,
    ...routeVehicleExpenses,
    ...routeVehicleGroups,
    ...routeUnitsArchives,
    ...routeUnitsSwapping,
    ...routeUnitsTransfer,
    ...routeUnitGroups,
    ...routeUnits,
    ...routeCfgTemplates,
    ...routeReports,
    ...routeEventProfiles,
    ...routeEventPools,
    ...routeSimCards,
    ...routeGDSPOSimCards,
    ...routeUnitCommands,
    ...routeAssetTransfer,
    {
      name: 'login',
      path: '/login',
      component: () => import('@/views/login/Login')
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js